"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.psychiatricContraindicationMessages = exports.PsychiatricContraindication = void 0;
const schema_1 = require("../../../../schema");
var PsychiatricContraindication;
(function (PsychiatricContraindication) {
    PsychiatricContraindication["PRESENT"] = "PRESENT";
    PsychiatricContraindication["NONE"] = "NONE";
})(PsychiatricContraindication || (exports.PsychiatricContraindication = PsychiatricContraindication = {}));
exports.psychiatricContraindicationMessages = {
    [PsychiatricContraindication.PRESENT]: {
        id: "ltx.phaseI.consultations.psychiatricAssessment.psychiatricContraindication.PRESENT",
        defaultMessage: "Kontraindikáció"
    },
    [PsychiatricContraindication.NONE]: {
        id: "ltx.phaseI.consultations.psychiatricAssessment.psychiatricContraindication.NONE",
        defaultMessage: "Nincs kontraindikáció"
    }
};
const psychiatricContraindication = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PsychiatricContraindication.PRESENT),
    schema_1.Schema.singleChoiceItem(PsychiatricContraindication.NONE)
])
    .expiration(31104000)
    .interpretation({ vocab: "ltx", code: "psychiatric_assessment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ psychiatricContraindication })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "34043003" });
